module.exports = __webpack_public_path__ + "img/Question-bg-7.6a5cbfe0.png";